export class Warnings {
  refExpediteurRequired = 'Aucune référence expéditeur encodée.';
  expediteurRequired = 'Aucun expéditeur encodé.';
  objetRequired = 'Aucun objet encodé.';
  remarquesRequired = 'Aucune remarque encodée.';
  dateDocumentRequired = 'Aucune date de document encodée.';
  dateEcheanceRequired = "Aucune date d'échéance encodée.";
  codeClassementRequired = 'Aucun code de classement sélectionné.';
  dossierClassementRequired = 'Aucun code de classement sélectionné.';
  natureRequired = 'Aucune nature sélectionnée.';
  sourceRequired = 'Aucune source sélectionnée.';
  refRecommandeRequired = 'Aucune référence recommandé encodée.';
  dateEntreeDocumentInvalide = "Date d'entrée du document non valide.";
  dateDocumentInvalide = 'Date du document non valide : erronée ou vide.';
  dateDocumentSuperieureDateEntree = "La date du document est supérieure à la date d'entrée/sortie.";
  DateDocumentSuperieureDateEntree = "La date du document est supérieure à la date d'entrée/sortie.";
  dateDocumentErronee = 'La date du document est invalide et ne passe donc pas les vérifications du paramétrage système.';
  dateEcheanceInferieurOuEgaleDateEntree = "La date d'échéance du document est inférieure ou égale à la date d'entrée/sortie.";
  DateEcheanceInferieurOuEgaleDateEntree = "La date d'échéance du document est inférieure ou égale à la date d'entrée/sortie.";
  CreationContactAvecTypeContactImpossible = "Création du contact impossible avec ce type de contact, vous n'avez pas le droit";
  [key: string]: string;
}
